export const ACTIONS_CLOSED = 'moreButton/ACTIONS_CLOSED';

export const actionsClosed = (payload) => ({
  type: ACTIONS_CLOSED,
  payload,
});
